import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { getWirelessData } from '../../../../../../services/api';
import { rel } from '../../../../../../utils/rel';
import AsideTitle from '../../../../components/asideTitle';
import errorBoundary from '@ifeng/errorBoundary';

class Wireless extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        data: [],
    };

    async componentDidMount() {
        try {
            const data = await getWirelessData();

            this.setState({ data });
        } catch (e) {
            console.error(e);
        }
    }

    render() {
        const { data } = this.state;
        const { content } = this.props;

        return (
            <div className={styles.wireless}>
                {data && data.length > 0 ? (
                    <AsideTitle title={content.title}>
                        <span className={styles.link}>
                            {content.link.map((item, index) => (
                                <a key={index} href={item.url} target="_blank" rel={rel}>
                                    {item.title}
                                </a>
                            ))}
                        </span>
                    </AsideTitle>
                ) : (
                    ''
                )}
                <ul className={styles.list}>
                    {data.map(item => (
                        <li key={item.id}>
                            <a href={item.link_url} target="_blank" rel={rel}>
                                <img src={item.image_url} alt={item.title} width="140" height="80" border="0" />
                            </a>
                            <p>
                                <a href={item.link_url} target="_blank" rel={rel}>
                                    {item.title}
                                </a>
                            </p>
                        </li>
                    ))}
                </ul>
            </div>
        );
    }
}

export default errorBoundary(Wireless);
